import React from "react";

const StartNowBlocks2 = ({ className, ...props }) => {
  return (
    <svg
      width="434"
      height="246"
      viewBox="0 0 434 246"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g filter="url(#filter0_f_2918_7928)">
        <ellipse
          cx="217"
          cy="180.5"
          rx="172"
          ry="20.5"
          fill="url(#paint0_radial_2918_7928)"
        />
      </g>
      <path
        d="M263.059 104.795L269.579 114.198L297.404 111.751L290.884 102.353L263.059 104.795Z"
        fill="url(#paint1_linear_2918_7928)"
      />
      <path
        d="M290.884 102.352L297.404 111.751L299 85.3947L292.476 75.9922L290.884 102.352Z"
        fill="url(#paint2_linear_2918_7928)"
      />
      <path
        d="M261.467 131.16L267.987 140.558L269.579 114.197L263.059 104.795L261.467 131.16Z"
        fill="url(#paint3_linear_2918_7928)"
      />
      <path
        d="M233.638 133.603L240.158 143.001L267.987 140.558L261.467 131.16L233.638 133.603Z"
        fill="url(#paint4_linear_2918_7928)"
      />
      <path
        d="M236.826 80.8773L233.638 133.602L261.467 131.16L263.059 104.795L290.884 102.352L292.476 75.9922L236.826 80.8773Z"
        fill="url(#paint5_radial_2918_7928)"
      />
      <g filter="url(#filter1_d_2918_7928)">
        <path
          d="M240.69 79.4239L247.215 88.8264L281.045 85.8542L274.52 76.4561L240.69 79.4239Z"
          fill="url(#paint6_linear_2918_7928)"
        />
        <path
          d="M274.52 76.4561L281.045 85.8542L282.981 53.8078L276.461 44.4053L274.52 76.4561Z"
          fill="url(#paint7_linear_2918_7928)"
        />
        <path
          d="M238.754 111.475L245.274 120.873L247.215 88.8263L240.69 79.4238L238.754 111.475Z"
          fill="url(#paint8_linear_2918_7928)"
        />
        <path
          d="M204.924 114.442L211.448 123.845L245.274 120.873L238.754 111.475L204.924 114.442Z"
          fill="url(#paint9_linear_2918_7928)"
        />
        <path
          d="M208.801 50.3453L204.924 114.443L238.754 111.475L240.69 79.4239L274.52 76.4561L276.461 44.4053L208.801 50.3453Z"
          fill="url(#paint10_radial_2918_7928)"
        />
      </g>
      <g filter="url(#filter2_d_2918_7928)">
        <path
          d="M216.097 53.4269L222.617 62.825L260.547 59.4982L254.023 50.0957L216.097 53.4269Z"
          fill="url(#paint11_linear_2918_7928)"
        />
        <path
          d="M254.023 50.0956L260.547 59.4981L262.719 23.5646L256.199 14.1621L254.023 50.0956Z"
          fill="url(#paint12_linear_2918_7928)"
        />
        <path
          d="M213.925 89.3515L220.445 98.754L222.617 62.8249L216.097 53.4268L213.925 89.3515Z"
          fill="url(#paint13_linear_2918_7928)"
        />
        <path
          d="M176 92.6827L182.52 102.085L220.445 98.7541L213.925 89.3516L176 92.6827Z"
          fill="url(#paint14_linear_2918_7928)"
        />
        <path
          d="M180.344 20.8244L176 92.6827L213.925 89.3516L216.097 53.4268L254.023 50.0956L256.199 14.1621L180.344 20.8244Z"
          fill="url(#paint15_radial_2918_7928)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_2918_7928"
          x="0"
          y="115"
          width="434"
          height="131"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="22.5"
            result="effect1_foregroundBlur_2918_7928"
          />
        </filter>
        <filter
          id="filter1_d_2918_7928"
          x="184.924"
          y="28.4053"
          width="118.057"
          height="119.439"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2918_7928"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2918_7928"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_2918_7928"
          x="164"
          y="0.162109"
          width="126.719"
          height="127.923"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8" dy="6" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2918_7928"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2918_7928"
            result="shape"
          />
        </filter>
        <radialGradient
          id="paint0_radial_2918_7928"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(217 180.5) rotate(90) scale(20.5 172)"
        >
          <stop />
          <stop offset="1" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_2918_7928"
          x1="279.462"
          y1="95.5896"
          x2="280.56"
          y2="113.536"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#007AD3" />
          <stop offset="1" stopColor="#002ABF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2918_7928"
          x1="286.174"
          y1="60.3782"
          x2="299.787"
          y2="112.006"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#007AD3" />
          <stop offset="1" stopColor="#002ABF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2918_7928"
          x1="255.597"
          y1="121.963"
          x2="270.016"
          y2="122.993"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#007AD3" />
          <stop offset="1" stopColor="#002ABF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2918_7928"
          x1="250.259"
          y1="124.113"
          x2="251.137"
          y2="144.686"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#007AD3" />
          <stop offset="1" stopColor="#002ABF" />
        </linearGradient>
        <radialGradient
          id="paint5_radial_2918_7928"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(281.459 120.453) rotate(180) scale(60.5165 60.7399)"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="0.05" stopColor="#00E8FF" />
          <stop offset="0.17" stopColor="#00BBFF" />
          <stop offset="0.29" stopColor="#0095FF" />
          <stop offset="0.41" stopColor="#0076FF" />
          <stop offset="0.54" stopColor="#005EFF" />
          <stop offset="0.67" stopColor="#004CFF" />
          <stop offset="0.82" stopColor="#0042FF" />
          <stop offset="1" stopColor="#003FFF" />
        </radialGradient>
        <linearGradient
          id="paint6_linear_2918_7928"
          x1="259.91"
          y1="73.2037"
          x2="261.443"
          y2="88.2124"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="1" stopColor="#003AEB" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_2918_7928"
          x1="278.925"
          y1="32.9936"
          x2="278.631"
          y2="86.9836"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="1" stopColor="#003AEB" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_2918_7928"
          x1="229.233"
          y1="103.232"
          x2="251.448"
          y2="98.2856"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="1" stopColor="#003AEB" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_2918_7928"
          x1="223.062"
          y1="106.817"
          x2="226.194"
          y2="123.355"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="1" stopColor="#003AEB" />
        </linearGradient>
        <radialGradient
          id="paint10_radial_2918_7928"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(262.126 100.904) rotate(180) scale(93.8233 94.1696)"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="0.09" stopColor="#00E1FF" />
          <stop offset="0.25" stopColor="#00B0FF" />
          <stop offset="0.42" stopColor="#0087FF" />
          <stop offset="0.57" stopColor="#0068FF" />
          <stop offset="0.73" stopColor="#0051FF" />
          <stop offset="0.87" stopColor="#0044FF" />
          <stop offset="1" stopColor="#003FFF" />
        </radialGradient>
        <linearGradient
          id="paint11_linear_2918_7928"
          x1="236.674"
          y1="44.6985"
          x2="239.463"
          y2="64.4724"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00BEFF" />
          <stop offset="1" stopColor="#007BFF" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_2918_7928"
          x1="259.382"
          y1="23.1969"
          x2="256.747"
          y2="58.433"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00BEFF" />
          <stop offset="1" stopColor="#007BFF" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_2918_7928"
          x1="212.752"
          y1="76.4953"
          x2="224.729"
          y2="75.6175"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00BEFF" />
          <stop offset="1" stopColor="#007BFF" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_2918_7928"
          x1="197.13"
          y1="81.6475"
          x2="198.668"
          y2="101.345"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00BEFF" />
          <stop offset="1" stopColor="#007BFF" />
        </linearGradient>
        <radialGradient
          id="paint15_radial_2918_7928"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(184.435 26.4274) rotate(180) scale(109.415 109.819)"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="0.12" stopColor="#00FAFF" />
          <stop offset="0.27" stopColor="#00ECFF" />
          <stop offset="0.43" stopColor="#00D4FF" />
          <stop offset="0.59" stopColor="#00B3FF" />
          <stop offset="0.76" stopColor="#0089FF" />
          <stop offset="0.93" stopColor="#0055FF" />
          <stop offset="1" stopColor="#003FFF" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default StartNowBlocks2;
